import React from 'react'
//import PropTypes from 'prop-types'

/*import {
  NavLink,
  NavItem,
  Nav
} from 'reactstrap'

import closeImg from './../images/close.svg'
*/

const ChangePasswordNav = (/*{ goBack }*/) => {

  return (
    <>
      {/*<Nav className="mr-auto ml-auto" navbar>
        <NavItem className="nav-text">Changer votre mot de passe</NavItem>
      </Nav>*/}
      {/*<Nav className="mr" navbar>
        <NavItem className="my-auto">
          <NavLink onClick={goBack}>
            <img className="d-none d-lg-block" src={closeImg} alt="back" />
            <span className="d-lg-none d-xl-none"> Retour</span>
          </NavLink>
        </NavItem>
      </Nav>*/
      }
    </>
  )
}
/*
RegisterNav.propTypes = {
  goBack: PropTypes.func
}*/

export default ChangePasswordNav
